import app from 'firebase/app';
import 'firebase/auth';

import FirebaseConfig from '../config/FirebaseConfig';

const Firebase = app.initializeApp(FirebaseConfig);

export default Firebase;
